import { Dialog, Heading, IconArrowBigRight, IconLink } from "@idg-web-platform/pulse";
import css from "./returnInformationDialog.module.css";
import { useEffect, useRef } from "preact/hooks";

const ReturnInformationDialog = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const dialogRef = useRef<HTMLDialogElement>(null);

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    if (isOpen) {
      dialogRef.current?.showModal?.();
    } else {
      dialogRef.current?.close?.();
    }
  }, [isOpen]);

  useEffect(() => {
    dialogRef.current?.addEventListener("close", handleClose);
    return () => {
      dialogRef.current?.removeEventListener("close", handleClose);
    };
  }, []);

  return (
    <>
      <Dialog ref={dialogRef} role="dialog" class={css.returnInformationDialog}>
        <div>
          <Heading text={"Retouren"} sizeStep={2} />
        </div>

        <div className={css.description}>
          <Heading text={"Bis wann kann ich meine Artikel retournieren?"} sizeStep={0} />
          <p>
            Du hast ein Rückgaberecht von <strong> 14 Tagen </strong> ab Erhalt der Ware. Wenn Du
            INTERSPORT CLUB-Kunde bist, dann hast Du sogar <strong> 30 Tage </strong> Zeit deine
            Bestellung zu retournieren.
          </p>
        </div>

        <div className={css.description}>
          <Heading text={"Retourenschein und Label ausdrucken"} sizeStep={0} />
          <p>
            Du kannst hier das PDF mit dem Retourenschein und dem Label herunterladen und selbst
            ausdrucken. Folge dabei den Anweisungen innerhalb des PDFs und bringe das Label auf dem
            Paket an.
          </p>
        </div>

        <div className={css.description}>
          <Heading text={"was muss ich dabei beachten?"} sizeStep={0} />
          <div>
            <ul>
              <li>
                Jeder Artikel muss zurück an den Versender, von dem du den Artikel erhalten hast.
                Daher hat jedes Paket seinen eigenen Retourenschein und Retourenlabel.
              </li>
              <li>
                Solltest du Artikel aus verschiedenen Paketen retournieren wollen, dann dürfen diese
                nicht zusammen in eine Rücksendung gepackt werden.
              </li>
              <li>
                Es kann sein, dass du die Pakete dann auch bei unterschiedlichen Paketdienstleistern
                abgeben musst.
              </li>
            </ul>
          </div>
        </div>

        <div>
          <IconLink
            text="Weiter Informationen zu Retouren"
            href={""}
            iconComponent={<IconArrowBigRight />}
            iconPosition="right"
          />
        </div>
      </Dialog>
    </>
  );
};

export default ReturnInformationDialog;
